/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable, NgZone } from '@angular/core';
import { initialize, LDClient, LDContext } from 'launchdarkly-js-client-sdk';
import { Subject, Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyService {
    private ldClient: LDClient;
    private isUserIdentified = false;
    private ready: Subject<boolean> = new Subject<boolean>();
    get ready$(): Observable<boolean> {
        return this.ready.asObservable();
    }

    constructor(
        private _ngZone: NgZone,
        private readonly configService: ConfigService
    ) {
        this.ldClient = this.getNewClient();
    }

    private getNewClient(): LDClient {
        return this._ngZone.runOutsideAngular(() => {
            return initialize(
                this.configService.config.launchdarklyApiKey,
                {
                    kind: 'user',
                    key: 'anonymous_user',
                    anonymous: true,
                },
                {
                    sendEventsOnlyForVariation: true,
                    streaming: true,
                }
            );
        });
    }

    public async setContext(context: LDContext): Promise<void> {
        await this.ldClient.identify(context);
        this.isUserIdentified = true;
    }

    public getContext(): LDContext {
        return this.ldClient.getContext();
    }

    public isFeatureActive(featureKey: string): boolean {
        return (
            this.isUserIdentified && this.ldClient.variation(featureKey, false)
        );
    }
}
